import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {BaseComponent} from '../basecomponent.js';
import {RoutingService} from "../../service/routing/routingService";
import {ImportUtil} from '../../utils/importUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js';

/* global customElements */
class HelpGrid extends BaseComponent {
	
	static get properties() {
		return {				
		};
	}
	
	constructor() {
		super();
		
		var helpGrid = this;
		setTimeout(function(){
			helpGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var helpGrid = this;
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',										
					permissions: ['ADMIN_HELP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')
					],
					listeners: {
						click: function() {							
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,					
					permissions: ['ADMIN_HELP_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')
					],
					listeners: {
						click: function() {							
							actionAddEdit(grid.selectedItems[0]);
						}
					}				
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',
							permissions: ['ADMIN_HELP_MANAGEMENT:WRITE', 'ADMIN_HELP_MANAGEMENT:WRITE'],
							children:[
								ElementUtil.makeIcon('vaadin:upload', 'Import')
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							theme: 'error primary',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',
							disabled: true,
							permissions: ['ADMIN_HELP_MANAGEMENT:DELETE'],
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems[0]);
								}
							}
						}
					]
				}
				
			]
		});		
		
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true
			},			
			children: [				
				{						
					path: 'page',
					header: 'Page',
					width: '12em'
				},
				{						
					path: 'content',
					header: 'Content',
					'flex-grow': '1'
				},
				{
					path: 'updateDts',
					header: 'Update Date',
					width: '7em',
					renderer: function(root, column, rowData) {	
						root.innerHTML = TimeUtil.formatDateStandard(TimeUtil.parseDate(rowData.item.updateDts));
					}
				},
				{
					path: 'updateUser',
					header: 'Update User',
					width: '7em'										
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;
					grid.selectedItems = item ? [item] : [];
					if (grid.selectedItems.length > 0) {						
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = true;						
					}	
				}
			}
		});	
		
		var footer = ExportUtil.createExportFooter({
			grid: grid,
			itemid: 'primary',
			onDetail: function() {
				actionExport();
			}
		});
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbar,
				grid,
				footer.footerContainer
			]
		});		
		helpGrid.append(flexLayout);		
				
		var actionRefresh = function() {
			var loadMask = grid.showLoading();	
			Service.getHelpService().getAllHelp().then(function(data){
				loadMask.remove();
				
				grid.activeItem = null;
				grid.items = data;				
			});
		};
		actionRefresh();
		
		var actionAddEdit = function(record) {
			
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Add/Edit Help',
				icon: 'vaadin:edit',
				listeners: {
					ready: function() {
						
						addEditWin.show();
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [
										{
											tag: 'vaadin-text-field',
											label: 'Page',
											name: 'page',
											required: true,
											maxlength: 255,
											colspan: 2
										},
										{
											tag: 'dl-rich-text',
											itemid: 'content',
											label: 'Content',
											name: 'content',
											maxlength: 4096,
											editorheight: '400px',
											colspan: 2,
											required: true
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Post')
													],
													listeners: {
														click: function() {											
															if (formPanel.isValid()) {
																
																var data = formPanel.getData();	
																														
																if (record) {
																	data.helpId = record.helpId;
																}
																
																var loadMask = formPanel.showLoading('Saving Help...');
																Service.getHelpService().saveHelp(data).then(function(result){
																	loadMask.remove();
																	actionRefresh();
																	addEditWin.close();
																});
															}  else {
																window.DL.MessageUtil.showToastError('Check form make sure all require fields are entered.');
															}	
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]

						});
						addEditWin.addToContentElement(formPanel);	
												
						if (record) {
							formPanel.load(record);
						}
					}
				}
			});
	
		};

		var actionDelete = function(record) {

			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete help for page: ' + record.page  + ' ?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Deleting help...');													

							Service.getHelpService().deleteHelp(record.helpId).then(function(){
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Deleted help page: ' + record.page, {									
									theme: 'success'
								});
								actionRefresh();
							});															

						}	
					},
					{
						text: 'No'
					}
				]
			});					

		};

		var actionUpload = function() {
			var uploadWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Import Help File',
				icon: 'vaadin:upload',
				width: 450,
				height: 220,
				listeners: {
					ready: function() {
						uploadWin.show();

						var uploadHandler = function() {

							var uploadField = ElementUtil.query(uploadFormPanel, 'uploadField');

							if (!uploadField.files || uploadField.files.length < 1) {
								window.DL.MessageUtil.showOkMessage('A help import file is required.');
							} else {
								uploadField.uploadFiles();
							}

						};

						var uploadFormPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-upload',
									itemid: 'uploadField',
									'no-auto':  true,
									'max-files': 1,
									required: true,
									target: '/api/resource/help/import',
									headers: ImportUtil.getUploadHeader(),
									listeners: {
										'upload-request': function(event) {
										},
										'upload-success': function(event) {
											var responseData = JSON.parse(event.detail.xhr.responseText);
											if (responseData.uploadFile) {
												//error
												window.DL.MessageUtil.showOkMessage(
													responseData.uploadFile + '<br>' +
													responseData.uploadFileType ? responseData.uploadFileType : ''
												);
											} else {
												actionRefresh();
												uploadWin.close();
											}
										}
									}
								},
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:upload', ' Upload')
													],
													listeners: {
														click: function() {
															if (uploadFormPanel.isValid()) {
																uploadHandler();
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															uploadWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});
						uploadWin.addToContentElement(uploadFormPanel);

					}
				}


			});

		};

		var actionExport = function() {
			Service.getHelpService().exportHelp();
		};
		
	}
	
};
customElements.define('dl-help-grid', HelpGrid);


